import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import GstDetails from "../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../components/_utils/AccountCreationComponents/PanDetails";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { beneVerifyThisGST } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import RejectingTransactionPopup from "../../../Accounts/BeneficiaryAccount/BeneficiaryAcountApproval/RejectingTransactionPopup/RejectingTransactionPopup";
import AssociateAccountEdit from "../../../Accounts/BeneficiaryEditAccount/AssociateAccountEdit";
import "./index.css";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const FieldForcePanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,

  BenEnableNextButton,
  verifyPANisLoading,

  setIsArchived,
  isApproved,
  setIsApproved,

  setIsDennied,
  setIsPending,

  accountType,
  setAccountType,

  setShutViewAll,

  type,
  setShowAction,
  previousId,
  setIsActive,
  isActive,
  beneLookError,
  setNewMessage,

  setHideBlock,

  hideBlock,
  hideCreate,
  setNonArchive,
  nonArchive,
  previousBankNo,
  setPreviousBankNo,
  isLinkedAccount,
  setIsLinkedAccount,
  unachivedOpenPop,
  setUnachivedOpenPop,
  achivedOpenPop,
  setAchivedOpenPop,

  alreadyLinked,

  haveLinkNew,

  setPayload,
  payload,

  setShowAccInfo,
  associatedPan,
  setGSTPanExist,
  GSTPanExist,
  showRejectTnxPopup,
  setRejectTxnPopup,
  showPopup,
  setShowPopup,
}) => {
  const [isApprovedState, setIsApprovedState] = useState([]);

  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [isblur, setisblur] = useState(false);
  const [focusState, setFocusState] = useState({});
  const associatedAccountRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Active");
  const [slideDirection, setSlideDirection] = useState("right");
  const dispatch = useDispatch();
  const [GSTLinked, setGSTLinked] = useState(true);
  const [GSTLinkedMessage, setGSTLinkedMessage] = useState(false);
  const [showRejectAllTxnReson, setShowRejectAllTxnReson] = useState(false);
  const [newData, setNewData] = useState({
    gstin: "",
  });

  const [gstTempData, setGstTempData] = useState(null);
  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );

  const gstNumber =
    viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail;

  const { beneVerifyGST, isGSTError, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration.gstLength &&
      !customErrors["gstin"]
    ) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(beneVerifyThisGST({ search_string: payload.gstin }));
    } else if (payload?.gstin?.length === 15 && customErrors["gstin"]) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (!isGSTLoading) {
      if (beneVerifyGST?.status === true) {
        setGstVerified(true);
      } else if (beneVerifyGST?.status === false) {
        setGstVerified(false);
      }
    }
  }, [beneVerifyGST, isGSTLoading]);

  useEffect(() => {
    if (payload?.gstin?.length === GlobalConfiguration.gstLength) {
      let aa = payload.gstin.substring(
        2,
        payload.gstin.length - GlobalConfiguration.accountminLength,
      );
      if (aa === panNumber && beneVerifyGST?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa != panNumber && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (!payload?.gstin && verifiedPan && !verifyPANisLoading) {
      setGSTStatus(null);
    }
  }, [
    beneVerifyGST,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  const ActiveData = () => {
    setIsActive(false);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
    setIsPending(false);
    setNonArchive(false);
    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setAccountType({
      type: "",
      id: "",
    });
    setHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setIsActive(true);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setIsPending(false);
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");
    setNonArchive(false);
    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setShowAccInfo(false);
    setAccountType({
      type: "",
      id: "",
    });
  };

  useEffect(() => {
    let gstStoredData = gstTempData;
    let ActualGstno =
      viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail;
    let ActualPANno = viewAccountDetailData?.beneficiary_accounts[0]?.pan_no;
    let aa = payload?.gstin?.substring(2, payload?.gstin?.length - 3);
    if (viewAccountDetailLoading == false && viewAccountDetailData != null) {
      if (
        viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail ==
        undefined
      ) {
        if (!isGSTLoading && gstStoredData != null && payload.gstin != "") {
          if (payload.gstin?.length == 15 && GSTStatus) {
            let aa = payload.gstin.substring(2, payload.gstin.length - 3);
            if (aa === panNumber) {
              BenEnableNextButton(false);
              setGSTLinked(true);
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else {
            BenEnableNextButton(true);
          }
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          (GSTStatus == null || !GSTStatus) &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          GSTStatus &&
          payload.gstin?.length === 15
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else {
          BenEnableNextButton(true);
          setGSTLinked(false);
          setGSTLinkedMessage(false);
        }
      } else if (viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail) {
        if (!isGSTLoading) {
          if (ActualGstno != gstStoredData && gstStoredData != null) {
            if (payload.gstin?.length == 15 && GSTStatus) {
              let aa = payload.gstin.substring(2, payload.gstin.length - 3);
              if (aa === panNumber && GSTStatus) {
                BenEnableNextButton(false);
                setGSTLinked(true);
                setGSTLinkedMessage(true);
              } else if (aa !== panNumber && GSTStatus) {
                setGSTLinked(false);
                setGSTLinkedMessage(true);
                BenEnableNextButton(true);
              } else {
                BenEnableNextButton(true);
              }
            } else if (panNumber != ActualPANno && verifiedPan) {
              if (!GSTStatus) {
                BenEnableNextButton(true);
              } else {
                let aa = payload.gstin.substring(2, payload.gstin.length - 3);
                if (aa === panNumber && GSTStatus) {
                  BenEnableNextButton(false);
                  setGSTLinked(true);
                  setGSTLinkedMessage(true);
                } else if (aa !== panNumber && GSTStatus) {
                  setGSTLinked(false);

                  BenEnableNextButton(true);
                } else {
                  BenEnableNextButton(true);
                }
              }
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else if (
            GSTStatus == null &&
            !isGSTLoading &&
            panNumber != ActualPANno &&
            verifiedPan
          ) {
            BenEnableNextButton(false);
          } else if (GSTStatus && aa !== panNumber) {
            setGSTLinked(false);
          } else if ((GSTStatus || aa === panNumber) && gstVerified) {
            setGSTLinked(true);
            setGSTLinkedMessage(true);
          }
        } else if (ActualGstno == gstStoredData) {
          BenEnableNextButton(true);
          setGSTLinked(true);
          setGSTLinkedMessage(true);
        }
      }
    }
  }, [
    gstTempData,
    payload,
    GSTLinked,
    GSTStatus,
    gstVerified,
    isGSTLoading,
    viewAccountDetailData,
    viewAccountDetailLoading,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const checkAllValidations = () => {
    return GSTStatus;
  };

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value?.length === 1) {
        return;
      }

      if (name === "gstin") {
        const len = newValue.length;

        setGSTLinked(false);
        setGstVerified(false);

        if (len === GlobalConfiguration.gstLength) {
          setGstTempData(newValue);
          setGSTStatus(false);
        } else if (
          len > GlobalConfiguration.lengthCheckZero &&
          len < GlobalConfiguration.gstLength
        ) {
          setGSTStatus(false);
        } else {
          setGstTempData(null);
          setGSTStatus(null);
        }
      }
    }
  };

  const showErrors = (name) => {
    let errorMessage = customErrors[name];
    if (typeof errorMessage === "string") {
      errorMessage = { "Wrong input": [errorMessage] };
    }
    Object.entries(errorMessage)?.forEach(([errorType, errorMsg]) => {
      CommonToast({
        text: errorMsg[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    });
  };

  useEffect(() => {
    if (payload.gstin?.length > 0 && beneVerifyGST?.status === true) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (payload.gstin?.length > 0 && beneVerifyGST?.errors) {
      let errors = { ...customErrors };
      errors["gstin"] = beneVerifyGST.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [beneVerifyGST]);

  const getGSTInputElementDiv = (
    name,
    status,
    label,
    value,
    maxLength,
    xvalue,
    gstLinked,
  ) => {
    const getColor = () => {
      if (value?.length === 15) {
        if (status && gstLinked) return "var(--settled)";
        if ((!gstLinked && status) || !status) return "var(--failed)";
      }
      if (focusState[name]) return "var(--pending)";
      return "var(--text-primary)";
    };

    const color = getColor();

    const handleFocus = () => {
      setFocusState((prev) => ({ ...prev, [name]: true }));
    };

    const handleBlur = () => {
      setFocusState((prev) => ({ ...prev, [name]: false }));
      setisblur(true);
    };

    return (
      <div className="w-full flex flex-row items-center self-center text-center gap-4">
        <TextField
          className="w-full antialiased text-xl"
          id={`outlined-size-small-${name}`}
          size="small"
          variant="outlined"
          sx={{
            "& label.Mui-focused": {
              color: color,
            },
            "& label": {
              color: color,
            },
            "& .MuiOutlinedInput-root": {
              "borderRadius": "10px",
              "& fieldset": {
                borderColor: color,
                outline: "none !important",
                borderRadius: "10px",
              },
              "&:hover fieldset": {
                borderColor: color,
              },
              "&.Mui-focused fieldset": {
                borderColor: color,
              },
            },
          }}
          inputProps={{
            style: { color: "var(--text-primary)" },
            maxLength: maxLength,
          }}
          InputLabelProps={{ style: { color: color } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="w-[20px] h-[20px]">
                  {name === "gstin" && (
                    <>
                      {payload.gstin?.length === 0 ? null : (
                        <>
                          {panNumber?.length >= 10 ? (
                            gstVerified && payload.gstin?.length === 0 ? (
                              <img
                                src={
                                  "https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                }
                                alt="Skipped Verification Icon"
                                onClick={() => showErrors(name)}
                                className="cursor-pointer w-4 h-4"
                              />
                            ) : (
                              gstVerified &&
                              GSTLinked &&
                              payload.gstin?.length === 15 && (
                                <img
                                  className="self-center w-5 h-5"
                                  src={
                                    "https://q2pay.in/new_assets/common/create_flow/verified_with_white_circle_green.svg"
                                  }
                                  alt="verified logo"
                                />
                              )
                            )
                          ) : (
                            <img
                              src={
                                "https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                              }
                              alt="Skipped Verification Icon"
                              onClick={() => showErrors(name)}
                              className="cursor-pointer w-4 h-4"
                            />
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </InputAdornment>
            ),
          }}
          label={label}
          name={name}
          onBlurCapture={handleBlur}
          onFocus={handleFocus}
          onChange={handleChange}
          value={value}
          autoComplete="off"
        />
      </div>
    );
  };

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  let haveAcheived = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "denied";
  });
  let haveRejected = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "rejected";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "blocked";
  });

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setPreviousBankNo(val?.bank_acc_no);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account archived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[0][0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });

          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setAccountType({ type: "", id: "" });
        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[0][0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  let haveLink = beneLookData?.beneficiary_accounts?.some((val) => {
    return (
      val?.id === accountType.id &&
      val?.bank_acc_no === previousBankNo &&
      val?.id !== previousId &&
      type === "editFlow"
    );
  });

  useEffect(() => {
    if (beneVerifyGST?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: beneVerifyGST?.gstin_details?.business_name,
      });
    }
  }, [beneVerifyGST]);

  if (GSTPanExist && payload?.gstin?.length == 0) {
    BenEnableNextButton(true);
  }

  const handleClosePopup = () => {
    setRejectTxnPopup(false);
    setShowRejectAllTxnReson(false);
  };

  const closeGSTDetailsModal = () => {
    setShowPopup(false);
  };

  const details =
    !beneLookLoading &&
    !verifyPANisLoading &&
    beneLookError === true &&
    verifiedPan &&
    panNumber?.length === GlobalConfiguration.owneraccountnormalLength;

  return (
    <div className="benePan_Main_edit_pan  lg:gap-gap-xl    pb-padding-xl overflow-y-auto overflow-x-hidden">
      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop opacity-light-opacity">
          <RejectingTransactionPopup
            type={"ArchiveAccount"}
            accountId={accountType.id}
            accountName={viewAccountDetailData?.beneficiary_accounts[0]?.name}
            handleClosePopup={handleClosePopup}
            setShowRejectAllTxnReson={setShowRejectAllTxnReson}
            setRejectTxnPopup={setRejectTxnPopup}
            flow={"edit"}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            setIsApproved={setIsApproved}
            setIsArchived={setIsArchived}
            setShutViewAll={setShutViewAll}
          />
        </div>
      )}

      <div className="  w-full  px-padding-md lg:px-padding-base  lg:w-width-md">
        {(isLinkedAccount || alreadyLinked) && verifiedPan ? (
          <div className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md">
            <p className=" text-text-secondary text-font-xs ">
              Looks like this PAN is already linked to this account. Please
              change provided PAN details to proceed.
            </p>
          </div>
        ) : nonArchive ? (
          <div className="new_message_text_block_nonarchiveEdit mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={
                "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
              }
              alt="info"
            />
            <p className="mt-[12px]">
              Archiving this account is disabled. As you're currently editing
              this account, archiving cannot be performed.
            </p>
          </div>
        ) : hideBlock ? (
          <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={
                "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
              }
              alt="info"
            />
            <p>To unblock this account, please contact customer support</p>
          </div>
        ) : hideCreate ? (
          <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={
                "https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
              }
              alt="info"
            />
            <p>
              Creating a new account adds it to the active accounts for the
              provided PAN
            </p>
          </div>
        ) : beneLookData?.status &&
          panNumber?.length === 10 &&
          verifiedPan &&
          !associatedPan &&
          viewAccountDetailData?.beneficiary_accounts[0]?.pan_no !==
            panNumber ? (
          <></>
        ) : null}

        {gstNumber ? (
          <div className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md ">
            <h5 className=" text-text-primary text-font-sm font-semibold">
              Since GST and PAN are linked
            </h5>
            <ul className="list-disc text-font-xs text-text-secondary pl-padding-button-l ">
              <li className="my-margin-sm">
                To edit PAN, the associated GST must also be provided.
              </li>
              <li>
                GST can only be replaced with other GSTs that are associated
                with the provided PAN.
              </li>
            </ul>
          </div>
        ) : null}

        <div className="dividepan_edit_pan h-auto">
          <PanDetails
            verifiedPan={verifiedPan}
            verifyPANisLoading={verifyPANisLoading}
            panNumber={panNumber}
            handlePanChange={handlePanChange}
            panDetails={panDetails}
          />
        </div>

        <div
          className="dividepan_edit_pan h-auto rounded-border-radius-md"
          disabled={type == "editFlow" && !verifiedPan}
          style={{
            backgroundColor:
              type == "editFlow" && !verifiedPan ? "var(--Blue-3)" : "",
            opacity:
              type == "editFlow" && !verifiedPan
                ? "var(--light-opacity)"
                : "var(--base-opacity)",
          }}
        >
          <GstDetails
            GSTStatus={GSTStatus}
            gstVerified={gstVerified}
            beneVerifyGST={beneVerifyGST}
            isGSTLoading={isGSTLoading}
            GSTLinked={GSTLinked}
            GstNumber={payload.gstin}
            setShowPopup={setShowPopup}
            handleChange={handleChange}
          />
        </div>
      </div>

      <div className="w-width-full flex flex-col h-auto lg:w-width-md relative">
        {verifiedPan === true ? (
          <div className="w-full flex flex-col flex-1">
            <div className="flex-1">
              <div className="mx-margin-md lg:mx-margin-base">
                <AssociateAccountEdit
                  ActiveData={ActiveData}
                  DeactiveData={DeactiveData}
                  haveAcheived={haveAcheived}
                  haveDennied={haveDennied}
                  haveBlock={haveBlock}
                  haveRejected={haveRejected}
                  isApprovedState={isApprovedState}
                  haveApproved={haveApproved}
                  havePending={havePending}
                  isActive={isActive}
                  activeTab={activeTab}
                  setSlideDirection={setSlideDirection}
                  slideDirection={slideDirection}
                  setActiveTab={setActiveTab}
                  previousId={previousId}
                  addSpacesToNumber={addSpacesToNumber}
                  beneLookLoading={beneLookLoading}
                  verifiedPan={verifiedPan}
                  details={details}
                  type="field_force"
                />
              </div>
            </div>
          </div>
        ) : (
          <div
            className="dividepan_edit_pan pan_Details"
            style={{ visibility: "hidden" }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default FieldForcePanDetails;
